<template>
    <p v-if="!props.isCustomise && productType !== 'variable' && actButton?.stockStatus === 'instock' " class="stock in-stock">In Stock</p>
    <form
      :class="['cart', 'yith-wcpb-bundle-form']"
      action=""
      method="post"
      enctype="multipart/form-data"
    >

        <Bundle
            v-if="showBundle"
            :data="props.bundleData"
            @updatePrice="handlePriceUpdate"
            :isStatusBundle="isStatusBundle"
            @update:isStatusBundle="handleStatusUpdate"
        />
        <Variation
            v-if="!props.isCustomise && !isOutOfStock"
            :data="props.variableData"
            :productId="productData.ID"
            :engravingDesignStatus = "engravingDesignStatus"
            @update-option="handleNoOption"
            @update-selection="handleIsActiveUpdate"
            @quantity-elm="handleVariationStockQty"
            @update-preorder="handlePreOderUpdate"
            @updatePrice="handlePriceUpdate"
            @update-gallery-image="$emit('update-gallery-image', $event)"
            @update-sku="$emit('update-sku', $event)"
            @update-description="handleDescription"
            @variant-changed="handleVariantChange"
            
        />
          <VariationCustomise
            v-if="props.isCustomise"
            :data="props?.variableData"
            :checkPixiu="props?.breadCrumbChild"
            :productId="productData.ID"
            :idsFirst="props?.idsFirstActive"
            :slug="props?.slug"
            :priceInfo = "props?.priceInfo"
            :customiseNameNecklace="props?.customiseNameNecklace"
            :multiCustomiseNameNecklace="props?.multiCustomiseNameNecklace"
            :charsWeight="props.charsWeight"
            :customiseBackNameNecklace="props.customiseBackNameNecklace"
            :customiseFontVisualNameNecklace="props.customiseFontVisualNameNecklace"
            :checkChina="props.isCheckChina"
            :materialPriceData="props.materialPriceData"
            :saleDate = "props.saleDate"
            :materialMultiplierData="props.materialMultiplierData"
            :titleAtributeP="props?.titleAtributeP"
            @update-option="handleNoOption"
            @update-selection="handleIsActiveUpdate"
            @quantity-elm="handleVariationStockQty"
            @update-preorder="handlePreOderUpdate"
            @updatePriceCustomise="handlePriceUpdateCustomise"
            @update-gallery-image="$emit('update-gallery-image', $event)"
            @update-thumbnail-image="$emit('update-thumbnail-image', $event)"
            @update-description="handleDescription"
            @update-button-active="handleIsActiveUpdate"
            @update-sku="$emit('update-sku', $event)"
            @update-engraving-price="handleEngravingPrice"
            
        />

        <div class="alt-engraving-design-wrapper add-to-cart-form" :class="{ 'is-updated-engraving': isUpdatedEngraving }" v-if="showEngraving">
            <Engraving
                v-for="(item, index) in itemArr"
                :key="itemArr.length + '-' + item"
                :isChange="index"
                :keyEngraving="item"
                :data="props.engravingData"
                :priceInfo="props.priceInfo"
                :isNoOption="isNoOption"
                :index="index"
                :totalItems="itemArr.length"
                @updatePrice="handlePriceUpdate"
            />
        </div>
            <CustomiseEngraving
                v-if="props.isCustomise && props.engravingCustomise?.status == 'yes'"
                :customiseEngravingFee="props.engravingCustomise?.fee"
                :customiseEngravingMaxlength="props.engravingCustomise?.maxlength"
                @update-engraving-price="handleEngravingPriceCustom"
                @update:modelValue="handleModelValueUpdate"
                :priceInfo="props.priceInfo"
                :engravingPrice = "engravingPrice"
                :engravingData = "engravingData"
            />

        <Chain v-if="showChainOption" :data="props.chainOptionData" :priceInfo="props.priceInfo" @updatePrice="handlePriceUpdate" />
        <FreeChain v-if="props.freeChainOptionData.isChainOption" :data="props.freeChainOptionData"  />
        <FreeBracelet v-if="showFreeBracelet" :data="props.freeBraceletData" />
        <div v-if="isOutOfStock">
            <p class="stock out-of-stock">This product is currently out of stock and unavailable.</p>
        </div>
        
        <FindStores 
            v-if=" enableErp === '1'"
            :class="[
                'find-store-wrapper',
                { isOutOfStock }
              ]"
            :productName="productName"
            :productSKU="initialSku"
            :findStore="productData.stores" 
        />
        <AddToCartButton
         v-if="!isOutOfStock"
            :isButtonActive="props.isButtonActive"
            :actButton="props.actButton"
            :shippingDate="props.shippingDate"
            :isPre0rder="props.isPre0rder"
            :productType="props.productType"
            :variable_description="variable_description"
            :product="productData"
            :isActive="isActive"
            :isStatusBundle="isStatusBundle"
            :gtmItem="props?.gtmItem"
            @handleWishlist="clickWishlist"
        />
        
        <StickyBar
            v-if="!isOutOfStock"
            :isButtonActive="props.isButtonActive"
            :thumbnailStickyBar="isCustomise ? thumbnailStickyBarCustomise : thumbnailStickyBar"
            :titleStickyBar="titleStickyBar"
            :priceInfo="priceInfo"
            :actButton="actButton"
            :productId="productData.ID"
            :isActive="isActive"
            :isStatusBundle="isStatusBundle"
            @handleWishlist="clickWishlist"
        />
    </form>
</template>
<script lang="ts" setup>
    import { ref, computed, onMounted } from "vue";
    import AddToCartButton from "./AddToCartButton.vue";
    import FreeBracelet from "./Layouts/FreeBracelet.vue";
    import Chain from "~/components/Product/SingleProduct/Layouts/Chain.vue";
    import FreeChain from "~/components/Product/SingleProduct/Layouts/FreeChain.vue";
    import Variation from "~/components/Product/SingleProduct/Layouts/Variable.vue";
    import Engraving from "~/components/Product/SingleProduct/Layouts/Engraving.vue";
    import StickyBar from "~/components/Product/SingleProduct/Layouts/StickyBar.vue";
    import VariationCustomise from "~/components/Product/SingleProduct/Layouts/VariableCustomise.vue";
    import CustomiseEngraving from "~/components/Product/SingleProduct/Layouts/EngravingCustomise.vue";
    import Bundle from "./Layouts/Bundle.vue";
    import FindStores from "~/components/Product/SingleProduct/Layouts/FindStore.vue";
    //import EngagementRingAppointment from "~/pages/engagement-ring-appointment.vue";
    import type { IAPIResponseError } from '~/types/apiResponseError';
    import { useCustomGtm } from '~/composables/useEventTagManager';
    import { useInsiderSdk } from '~/composables/insiderSdk';
    import OutOfStockNotification from "../OutOfStockNotification.vue";
    const userStore = useUserStore();
    const {
        singleAddWishListEventTracking, singleRemoveWishListTracking
    } = useCustomGtm();
    const {
        trackInsiderSdkEvent
    } = useInsiderSdk();
    // import VariationsForm from "./Layouts/VariationsForm.vue";
    const { $ajax } = useNuxtApp();
    const isActive = ref(false);

    const props = defineProps({
        isCustomise: {
            type: Boolean,
            default: false
        },
        engravingCustomise: {
            type: Object,
            default: 'no'
        },
        breadCrumbChild: {
            type: Boolean,
            default: false
        },
        thumbnailStickyBarCustomise: {
        type: String,
            default: ''
        },
        materialPriceData: {
            type: Object as PropType<Record<string, string>>,
            default: () => ({})
            },
        materialMultiplierData: {
            type: Object as PropType<Record<string, number>>,
            default: () => ({})
            },
        charsWeight: {
            type: Object as PropType<Record<string, Record<string, number>>>,
            default: () => ({})
        },
         titleAtributeP: {
            type: Object,
            default: () => ({})
        },
        slug: {
            type: String,
            default: 'no'
        },
        customiseNameNecklace: {
            type: Array,
            default: 'no'
        },
        multiCustomiseNameNecklace: {
            type: Array,
            default: 'no'
        },
        customiseBackNameNecklace: {
            type: Object,
            default: () => ({})
        },
        customiseFontVisualNameNecklace: {
            type: Object,
            default: () => ({})
        },
        isCheckChina: {
            type: String,
            default: ''
        },
        customiseEngravingFee: {
            type: String,
            default: '0'
        },
        idsFirstActive: {
            type: String,
            default: ''
        },

        isPre0rder: {
            type: Boolean,
            default: false
        },
        isButtonActive: {
            type: Boolean,
            default: true
        },
        freeBraceletData: {
            type: Object,
            default: null
        },
        chainOptionData: {
            type: Object,
            default: null
        },
        freeChainOptionData: {
            type: Object,
            default: null
        },
        engravingData: {
            type: Object,
            default: null
        },
        bundleData: {
            type: Object,
            default: null
        },
        priceInfo: {
            type: Object,
            default: null
        },
        priceInfoInit: {
            type: Object,
            default: null
        },
        actButton: {
            type: Object,
            default: null
        },
        variableData: {
            type: Object,
            default: null
        },
        product:{
            type: Object,
            default: null,
        },
        shippingDate:{
            type: Object,
            default: null,
        },
        isActive: {
            type: Boolean,
            default: false
        },
        productType:{
            type: String,
            default: ''
        },
        gtmItem: {
            type: Object,
        },
        saleDate : {
            type: Object,
            default: ''
        },
        engravingDesignStatus: {
            type: String,
            default: 'instock'
        },
        initialSku: {

            type: String,
            default: ''
        },
        enableErp: {
        type: String,
            default: '0'
        }

    });
    const productData = props.product;
    const productName = productData.post_title;
    interface IResponse {
        success: boolean;
        data: any[];
    };

    const clickWishlist = (id_item: number) => {
        let all_item_wishlist = JSON.parse(localStorage.getItem('all_item_wishlist') || 'null');
        let list_wishlist = JSON.parse(localStorage.getItem('list_wishlist') || '[]');
        id_item = Number(id_item);

        if (all_item_wishlist !== null) {
            toggleItemInWishlist(all_item_wishlist, id_item);
            localStorage.setItem('all_item_wishlist', JSON.stringify(all_item_wishlist));
        }
        toggleItemInWishlist(list_wishlist, id_item);
        localStorage.setItem('list_wishlist', JSON.stringify(list_wishlist));

        like_item_wishlist(id_item);
        isActive.value = !isActive.value;
    };
    const like_item_wishlist = async(id_item: Number) => {
        try {
            const response = await $ajax.get<IResponse>(`wp-json/skj/v1/wishlist/like?id_item=${id_item}`,{ headers: {"Authorization": `Bearer ${userStore.csrf}`,'X-API-Server': userStore.csrf_server} });
            if(response.success){

            }
        }catch(error) {
            if (error && typeof error === 'object' && 'data' in error) {
                const errorData = error.data as IAPIResponseError;
                console.log('wishlistdetailErrorCatch', errorData.code);
            } else {
                console.log('Unexpected error:', error);
            }
        }
    }

    const toggleItemInWishlist = (wishlist, id) => {
        const index = wishlist.indexOf(id);
        if (index === -1) {
            singleAddWishListEventTracking(productName)
            wishlist.push(id);
            trackInsiderSdkEvent(
                'insider_sdk_add_to_wishlist',
                '',
                ''
            );
        } else {
            singleRemoveWishListTracking(productName)
            wishlist.splice(index, 1);
        }
    };

    onMounted(() => {
        let list_all_wishlist = JSON.parse(localStorage.getItem('all_item_wishlist') || 'null');

        if( list_all_wishlist !== null) {
            const id_item = Number(productData.ID) ?? 0;
            const itemIndex = list_all_wishlist.indexOf(id_item);
            if (itemIndex === -1) {
                isActive.value = false;
            } else {
                isActive.value = true;
            }
        }else{
            let list_wishlist = JSON.parse(localStorage.getItem('list_wishlist') || '[]');
            const id_item = Number(productData.ID) ?? 0;
            const itemIndex = list_wishlist.indexOf(id_item);
            if (itemIndex === -1) {
                isActive.value = false;
            } else {
                isActive.value = true;
            }
        }
    });

    const variable_description = ref()
    const emit = defineEmits(['updatePriceCustomise','updatePrice' , 'update-selection', 'update-preorder', 'update-gallery-image','update-sku', 'update-oos']);

    const isOutOfStock = computed(() => {
        if (productData.isCustomise && productData?.productAttributes && Object.keys(productData.productAttributes).length === 0) {
            return true;
        }

        if (props.variableData && Array.isArray(props.variableData.variations)){
            if ( productData && productData.productType && productData.productType === 'variable'){
                if(props.variableData.variations.length === 0){
                    return true;
                }
            };

            if (props.variableData.variations.length > 0) {
                const allOutOfStock = props.variableData.variations.every(
                    (variation) => variation.stock_status === "outofstock"
                );
                if (allOutOfStock) return true;
            }

            if (props.variableData.variations.length === 0 &&  props.actButton?.stockStatus === "outofstock") {
                return true;
            }
        }

        return false;
    });

    watchEffect(() => {
        emit('update-oos', isOutOfStock.value);
    });

    interface Image{
        id : string;
        position: string;
        thumbnail: string;
        type: string;
        woocommerce_single: string;
        zoomsrc: string;
    }
    const thumbnailStickyBar = ref();
    const titleStickyBar = ref();

    const productGallery = productData.gallery;
    const productType = productData.productType;
    const firstImageItem = productGallery.find((item: Image) => item.type === "image");
    thumbnailStickyBar.value = firstImageItem ? firstImageItem.thumbnail : null;
    titleStickyBar.value = productData.post_title;
    const showChainOption = computed(() =>
        props.chainOptionData && props.chainOptionData.isChainOption
    );

    const showEngraving = computed(() =>
        props.engravingData && props.engravingData.isEngraving
    );

    const showBundle = computed(() =>
        props.bundleData && props.bundleData.isBundle
    );



    // Wnd : fixed update price when choose Engraving --end---
    const engravingPrice = ref(0);
    const engravingData = ref<any>();
    const handleModelValueUpdate = (price:number)=> {

       engravingPrice.value = Number(price);
    }
    const handleEngravingPrice = (data:any) => {
        engravingData.value = data ;
        emit('updatePrice', data);
    }
    // Wnd : fixed update price when choose Engraving --end---

    const handlePriceUpdate = (updatedPriceInfo: any ) => {
        emit('updatePrice', updatedPriceInfo);
    };

    const handlePriceUpdateCustomise = (updatedPriceInfo: any) => {
        emit('updatePriceCustomise', updatedPriceInfo);
    };

    const handleVariationPrice = (data: any) => {
    console.log('🔥 variation price', data);
    emit('updatePriceCustomise', data);
};

const handleEngravingPriceCustom = (data: any) => {
    console.log('🔥 engraving price', data);

    // nếu cần cộng thêm giá:
    emit('updatePriceCustomise', data);
};


    const handleIsActiveUpdate = (updatedIsActive: any) => {
        emit('update-selection', updatedIsActive);
    };

    const handlePreOderUpdate = (updatedPreOder: any) => {
        emit('update-preorder', updatedPreOder);
    };

    const handleDescription = (updatedDescription: any) => {
        if(updatedDescription){
            variable_description.value = updatedDescription
        }else{
            variable_description.value = ''
        }
    }
    const updatedQuantity = ref(1);
    const itemArr = ref<number[]>([]);
    const isUpdatedEngraving = ref(false);
    const handleVariationStockQty = (quantity: number) => {
        updatedQuantity.value = quantity;
        itemArr.value = Array.from({ length: updatedQuantity.value }, (_, i) => i);
        if (!isUpdatedEngraving.value){
            isUpdatedEngraving.value = true;
        }
    }

    const isNoOption = ref(false);
    const handleNoOption = () =>{
        isNoOption.value =  !isNoOption.value;
    }

    const showFreeBracelet = computed(() =>
        props.freeBraceletData && props.freeBraceletData.isFreeBracelet
    );

    const isStatusBundle = ref(true);
    const handleStatusUpdate = (isStatus: boolean) =>{
        isStatusBundle.value = isStatus;
        // console.log('isStatusBundle', isStatusBundle.value);
    }
    const handleVariantChange = (mutableSelectedOptions) => {
    emit('variant-changed', mutableSelectedOptions)
    }
</script>
